const features = [
  {
    icon: "ri-qr-code-line",
    title: "QR Code Self-Ordering",
    description:
      "Let your customers scan, browse, and order directly from their phones. No waiting for staff — faster service, happier guests, and higher table turnover.",
    benefits: ["Instant menu access", "Contactless payment", "Real-time order sync"],
    imageUrl:
      "/images/feature-qr.jpg",
  },
  {
    icon: "ri-computer-line",
    title: "Kitchen Display System",
    description:
      "Replace paper tickets with a smart digital display. Orders flow directly from the table to the kitchen, reducing errors and speeding up prep time.",
    benefits: ["Live order tracking", "Priority queuing", "Performance analytics"],
    imageUrl:
      "/images/feature-kds.jpg",
  },
  {
    icon: "ri-smartphone-line",
    title: "Captain App Access",
    description:
      "Give your floor managers a powerful mobile tool. Manage tables, track orders, handle payments, and communicate with the kitchen — all from a single app.",
    benefits: ["Table management", "Staff coordination", "Payment processing"],
    imageUrl:
      "/images/feature-captain.jpg",
  },
];

export default function Features() {
  return (
    <section id="features" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-primary-700 bg-primary-100 rounded-full mb-4">
            Core Features
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Everything Your Restaurant Needs
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Three powerful tools working together to streamline your entire
            restaurant operation from order to plate.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-50 border border-background-200 rounded-lg p-6 md:p-8 hover:border-primary-300 transition-all duration-300 flex flex-col"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-6 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>

              <div className="w-full aspect-[4/3] rounded-lg overflow-hidden mb-6">
                <img
                  src={feature.imageUrl}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={feature.title}
                />
              </div>

              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-3">
                {feature.title}
              </h3>

              <p className="text-sm text-foreground-600 leading-relaxed mb-5 flex-1">
                {feature.description}
              </p>

              <ul className="space-y-2">
                {feature.benefits.map((benefit) => (
                  <li
                    key={benefit}
                    className="flex items-center gap-2 text-xs md:text-sm text-foreground-700"
                  >
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-check-line text-xs"></i>
                    </span>
                    {benefit}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}